<template>
  <div class="mp3-tool">
    <img src="@/assets/image/zanting.png" class="audio-image" v-if="playStatus" alt="">
    <img src="@/assets/image/bofang.png" class="audio-image" v-else alt="">
    <div style="display: flex;align-items: center;">
      <el-select size="mini" v-model="playbackRate" placeholder="请选择" @change="changePlaybackRate">
        <el-option
          v-for="item in playbackRates"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
    </div>

    <div class="audio_container">
      <div class="audio_container_box">
        <div class="audio_container_box_jindu progress-container" @click="seek($event)">
          <div class="jindu" :style="{ width: scrollerwidth }"></div>
        </div>
        <div class="audio_container_box_time">{{ timeLength }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    srcUrl: {
      default: ""
    }
  },

  data() {
    return {
      audio:         null,
      playStatus:    false,//播放状态
      isAudioReady:  false,
      readyEmitted:  false,
      pendingPlay:   false,
      rafId:         null,
      duration:      0,  //音频时长
      left:          0,//剩余时长
      scrollerwidth: "0%",      //进度条
      timer:         null,      //定时器
      audioListeners: null,
      playbackRate: 1.0,
      playbackRates: [
        {
          label: 'x2.0',
          value: 2.0
        },
        {
          label: 'x1.5',
          value: 1.5
        },
        {
          label: 'x1.25',
          value: 1.25
        },
        {
          label: 'x1.0',
          value: 1.0
        },
        {
          label: 'x0.75',
          value: 0.75
        },
        {
          label: 'x0.5',
          value: .5
        }
      ]
    }
  },
  computed: {
    timeLength: {
      get() {
        return this.convertToTime(parseInt(this.left));
      },
      set(value) {
        console.log('value',value);
        return parseInt(value)
      }
    }
  },
  watch:    {
    left:   {
      handler(newValue) {
        console.log('newValue',newValue);
        this.timeLength = this.convertToTime(parseInt(newValue))
        console.log('timeLength',this.timeLength);
        this.scrollerwidth = this.computedPer()
      }
    },
    srcUrl: {
      handler(newValue) {
        console.log('音乐返回值', newValue)
        this.initAudio()
      }
    }
  },

  created() {
    this.initAudio()
  },
  destroyed() {
    this.cleanupAudio()
    this.stopProgressLoop()
    clearInterval(this.timer)
  },
  methods: {
    seek(event) {
      if(this.playStatus) {
        const progressContainer = this.$el.querySelector('.progress-container');
        const rect = progressContainer.getBoundingClientRect();
        const offsetX = event.clientX - rect.left;
        const width = rect.width;
        const newTime = (offsetX / width) * this.duration;
        this.audio.currentTime = newTime;
        let that =this;
        setTimeout(function(){
          that.left = that.duration - newTime;
        },100);
      }
    },
    changePlaybackRate(e) {
      if (this.audio) {
        this.audio.playbackRate = this.playbackRate;
      }
    },
    normalizeSrcUrl(url) {
      if (!url || typeof url !== 'string') {
        return ''
      }
      return url.replace(/^https?:\/\/static\.yijishen\.com/i, 'https://cdnstatic.yijishen.com')
    },
    stopProgressLoop() {
      if (this.rafId) {
        cancelAnimationFrame(this.rafId)
        this.rafId = null
      }
    },
    cleanupAudio() {
      if (!this.audio) {
        return
      }
      this.stopProgressLoop()
      if (this.audioListeners) {
        Object.keys(this.audioListeners).forEach(eventName => {
          this.audio.removeEventListener(eventName, this.audioListeners[eventName])
        })
      }
      this.audio.pause()
      this.audio.src = ''
      this.audio.load()
      this.audioListeners = null
      this.audio = null
    },
    getResolvedDuration() {
      if (!this.audio) {
        return 0
      }
      const rawDuration = Number(this.audio.duration)
      if (Number.isFinite(rawDuration) && rawDuration > 0) {
        return rawDuration
      }
      const seekable = this.audio.seekable
      if (seekable && seekable.length > 0) {
        const seekableEnd = Number(seekable.end(seekable.length - 1))
        if (Number.isFinite(seekableEnd) && seekableEnd > 0) {
          return seekableEnd
        }
      }
      return 0
    },
    startProgressLoop(syncAudioState) {
      this.stopProgressLoop()
      syncAudioState()
      const loop = () => {
        if (!this.audio || this.audio.paused || this.audio.ended) {
          this.rafId = null
          return
        }
        syncAudioState()
        this.rafId = requestAnimationFrame(loop)
      }
      this.rafId = requestAnimationFrame(loop)
    },
    //初始化音频文件
    initAudio() {
      let _ = this;
      if (_.srcUrl === "") {
        console.log('src-url未设置,没有音频文件');
        return;
      }
      _.cleanupAudio()
      _.audio = new Audio();
      _.audio.preload = 'auto'
      _.audio.src = _.normalizeSrcUrl(_.srcUrl);
      _.isAudioReady = false
      _.readyEmitted = false
      _.pendingPlay = false
      _.playStatus = false
      _.duration = 0
      _.left = 0
      _.scrollerwidth = '0%'

      const syncAudioState = () => {
        if (!_.audio) {
          return
        }
        const duration = _.getResolvedDuration()
        const currentTime = Number(_.audio.currentTime || 0)
        if (duration > 0) {
          _.duration = duration
          _.left = Math.max(0, duration - currentTime)
          _.timeLength = _.convertToTime(_.left)
          _.scrollerwidth = _.computedPer()
        } else if (currentTime > 0) {
          _.left = 0
          _.scrollerwidth = '0%'
        }
      }

      const markReady = () => {
        if (!_.audio) {
          return
        }
        _.isAudioReady = true
        syncAudioState()
        if (!_.readyEmitted) {
          _.readyEmitted = true
          _.$emit('audio-ready', {
            duration: _.duration,
            srcUrl: _.srcUrl
          })
        }
        if (_.pendingPlay) {
          _.pendingPlay = false
          _.play()
        }
      }

      _.audioListeners = {
        loadedmetadata: markReady,
        durationchange: syncAudioState,
        canplay: markReady,
        canplaythrough: markReady,
        play: function () {
        _.playStatus = true
        _.pendingPlay = false
        syncAudioState()
        _.$emit('audio-play', {
          srcUrl: _.srcUrl,
          currentTime: Number(_.audio && _.audio.currentTime ? _.audio.currentTime : 0),
          duration: _.getResolvedDuration()
        })
        _.startProgressLoop(syncAudioState)
        },
        pause: function () {
        _.stopProgressLoop()
        if (!_.audio.ended) {
          _.playStatus = false
        }
        },
        error: function () {
        _.stopProgressLoop()
        _.playStatus = false
          _.pendingPlay = false
        },
        loadeddata: syncAudioState,
        timeupdate: syncAudioState,
        ended: function () {
        _.stopProgressLoop()
        _.playStatus = false
        _.pendingPlay = false
        _.left = 0
        _.timeLength = '00:00:00'
        _.scrollerwidth = '100%'
        clearInterval(_.timer)
        _.$emit('audio-ended')
        }
      }

      Object.keys(_.audioListeners).forEach(eventName => {
        _.audio.addEventListener(eventName, _.audioListeners[eventName])
      })
    },
    stop() {
      let _ = this;
      _.pendingPlay = false
      if (!_.audio) {
        return
      }
        _.stopProgressLoop()
        _.audio.pause();
        _.playStatus = false
        clearInterval(this.timer)
    },
    //播放暂停
    play() {
      let _ = this;
      if (this.audio === null) {
        alert("请配置音频资源");
        return
      }
      if (_.playStatus) {
        //暂停
        _.pendingPlay = false
        _.stopProgressLoop()
        _.audio.pause()
        _.playStatus = false
        clearInterval(this.timer)
      } else {
        if (!_.isAudioReady) {
          _.pendingPlay = true
          if (_.audio.readyState < 2) {
            _.audio.load()
          }
          return
        }
        _.audio.playbackRate = _.playbackRate;
        if (_.audio.readyState < 2) {
          _.audio.load()
        }
        const playPromise = _.audio.play()
        if (playPromise && typeof playPromise.then === 'function') {
          playPromise.then(() => {
            _.playStatus = true
          }).catch(() => {
            _.playStatus = false
            _.pendingPlay = false
          })
        } else {
          _.playStatus = true
        }
      }
      _.$emit("showPlayStatus", _.playStatus);
    },
    convertToTime(times) {
      if (typeof times === 'number') {
        if (times <= 0) {
          return '00:00:00';
        } else {
          let hh = parseInt(times / 3600); //小时
          let shh = times - hh * 3600;
          let ii = parseInt(shh / 60);
          let ss = shh - ii * 60;
          return (hh < 10 ? '0' + hh : hh) + ':' + (ii < 10 ? '0' + ii : ii) + ':' + (ss < 10 ? '0' + ss : ss);
        }
      } else {
        return '00:00:00';
      }
    },
    computedPer() {
      if (!this.duration) {
        return '0%'
      }
      let per = ((this.duration - this.left) / this.duration) * 100
      return `${Math.max(0, Math.min(100, per)).toFixed(2)}%`;
    }
  }
}
;
</script>
<style scoped>
.mp3-tool {
  display: flex;
}

.audio-image {
  width: 45px;
  height: 45px;
  margin-right: 10px;
}

.audio_container {
  padding-left: 20px;
  width: 100%;
}

.audio_container_box {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}

.audio_container_box_jindu {
  width: 100%;
  height: 6px;
  border-radius: 5px;
  overflow: hidden;
  background: rgba(238, 238, 238, 1);
  margin-right: 10px;
}

.jindu {
  height: 100%;
  border-radius: 5px;
  background: rgba(246, 112, 75, 1);
  transition: width 0.08s linear;
}

.audio_container_box_time {
  margin-right: 10px;
}
.el-select {
  width: 80px;
}
</style>
